const teamsNameMapping = {
  'hellas-verona': 'verona',
};

export { teamsNameMapping as default };



// WEBPACK FOOTER //
// ./src/lib/utils/teamMap/teamMap.js